module.exports = __webpack_public_path__ + "img/loader.7a8cbb70.gif";